<template>
<div class="site-header yo-fixed yo-color-primary" style="padding:0 10px;">

   
   <!--mobile -->
   
   <div class="row yo-text-n" v-if="$teras.app.device!='desktop'">
      <div class="col s10">{{$evento.profile.row.nome}} - v 21.001</div>
      <div class="col s2"><a class="button" v-on:click="$teras.event.emit('sidebarToggle')" ><i class="material-icons">menu</i></a></div>
      <!-- <div style="background:red;width:10px;height:40px;"></div> -->
   </div>

  <!-- desktop -->
   <div class="row yo-text-m" v-if="$teras.app.device=='desktop'">
      <div class="col s8 yo-align-left" style="height:96px;"><img style="height:80px;margin:8px 0;" :src="'/images/'+$evento.profile.row.id+'/head-pic.png'"  /></div>
      <div class="col s4 yo-valign-text-center" style="height:96px;">
         <div class="row yo-text-n">
            <div class="col s2m yo-valign-text-center" style="height:40px;"><router-link to="/home">HOME</router-link></div>
            <!-- <div class="col s3m yo-valign-text-center" style="height:40px;"><router-link to="/contatti">CONTACTS</router-link></div> -->
            <div class="col s2m yo-valign-text-center" style="height:40px;"><a :href="$evento.profile.row.website" target="blank">WEBSITE</a></div>
            <div class="col s2m yo-valign-text-center" style="height:40px;" v-if="$contatto.profile.row.id>0"><a href="#!" v-on:click="$teras.event.emit('logout')">LOGOUT</a></div>
         </div>
      </div>
   </div>

   
</div>
</template>

<script>
export default {
  name: 'site-header',
  components: {
     
  }
}
</script>
<style>
#app.device-tablet .site-header{
   
}
.site-header{

}.site-header > .row > div{
   line-height:40px;    
}.site-header a{
   display:block;
   text-align:center;
}.site-header a:first{
   border-left:none !important;
}.site-header a.button i, .footer-bottom a.button i{
    line-height: 40px;
    height: 40px;
    font-size: 3.2rem;
    color:#fff;
}
</style>
